import { IconButton, IconButtonProps, Tooltip } from "@mui/material";
import { SpeechBubbleIcon } from "~/icons";

export const NavigateToExceptionButton = ({
  onClick,
}: {
  onClick: IconButtonProps["onClick"];
}) => {
  return (
    <Tooltip title="Exception pending review" placement="top" arrow>
      <IconButton onClick={onClick} sx={{ p: 0 }}>
        <SpeechBubbleIcon color="warning" fontSize="small" />
      </IconButton>
    </Tooltip>
  );
};
